module.exports = __webpack_public_path__ + "img/point-in-circles.37f5401a.svg";